import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import styled from "styled-components";

interface LayoutProps {
  children: any;
  height?: string;
  width?: string;
  css?: string;
  noPadding?: boolean;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  height,
  width,
  css,
  noPadding,
}) => {
  return (
    <>
      <StyledLayout
        css={css}
        $height={height}
        $width={width}
        $noPadding={noPadding}
      >
        <Content>{children}</Content>
      </StyledLayout>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;

const StyledLayout = styled(Box)<{
  $height?: string;
  $width?: string;
  $noPadding?: boolean;
  css?: string;
}>`
  max-width: ${({ $width }) => $width || "35%"};
  width: ${({ $width }) => ($width ? $width : "35%")};
  margin: 1rem 0;
  padding: ${({ $noPadding }) => ($noPadding ? 0 : "1.5rem")};
  border: 1px solid #e8eaed;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  height: ${({ $height }) => $height};
  box-sizing: border-box;
  @media screen and (max-width: 767px) {
    min-width: ${({ $width }) => ($width ? "auto" : "90%")};
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    min-width: ${({ $width }) => ($width ? "auto" : "50%")};
  }
  ${({ css }) => css || ""}
  @media only screen and (max-width: 1024px) {
    padding: ${({ $noPadding }) => ($noPadding ? 0 : "1.5rem 0.5rem")};
  }
`;

const Header = styled.div``;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
